class RecentArticles extends HTMLElement {
  constructor() {
    super();
    this.imageSizes = [
      { name: 'xs', width: 180 },
      { name: 'sm', width: 360 },
      { name: 'md', width: 540 },
      { name: 'lg', width: 720 },
    ];
  }

  async connectedCallback() {
    if (!this.dataset.tag.length) {
      return;
    }
    const articles = await this.getArticles(this.dataset.tag, parseInt(this.dataset.limit ?? 3));
    const template = this.buildTemplate({
      articles,
      aspectRatio: parseFloat(this.dataset.aspectRatio),
      showDate: this.dataset.showDate === 'true',
      showAuthor: this.dataset.showAuthor === 'true',
      showLink: this.dataset.showLink === 'true',
    });
    this.innerHTML = `<div ${this.dataset.sliderAttributes}>${template}</div>`;
  }

  buildTemplate({ articles, aspectRatio, showDate, showAuthor, showLink }) {
    return articles.map(({ title, authorV2, publishedAt, image, onlineStoreUrl }, index) => {
      let ratio = aspectRatio;
      if (!ratio && (image?.height && image?.width)) {
        ratio = image.width / image.height;
      }
      return `
        <div class="${this.dataset.itemClasses}" data-item data-carousel-slide>
          <div class="article__item">
            <div class="article__item-image" data-grid-slide>
              <a href="${onlineStoreUrl}">
                <div
                  class="relative block w-full h-full overflow-hidden ${ratio ? 'aspect-[--wh-ratio]' : ''}"
                  style="--wh-ratio:${ratio}"
                >
                  <img
                    class="block overflow-hidden w-full h-full reposition-background-mobile object-cover"
                    alt="${image.altText}"
                    loading="lazy"
                    src="${image.url}"
                    srcset="${this.imageSizes.map(({ name, width }, index) => (
                      image[name] + ' ' + width + 'w'
                    )).join(', ')}"
                    style="object-position: var(--focal-point, center);"
                  >
                </div>
              </a>
            </div>
            <div class="article__item-content">
              <div class="article__item-meta">
                ${showDate ? `
                  <span class="article__item-date">
                    <time>${dayjs(publishedAt).format('MMMM DD, YYYY')}</time>
                  </span>
                ` : ''}
              </div>
              <h3 class="article__item-title heading-size-6 mb-0">
                <a href="${onlineStoreUrl}">${title}</a>
              </h3>
              ${showAuthor ? `
                <div class="article__item-author">
                  <span>By ${authorV2.name}</span>
                </div>
              ` : ''}
            </div>
            ${showLink ? `<a class="text-link-bare" href="${onlineStoreUrl}">Read more</a>` : ''}
          </div>
        </div>
      `;
    }).join('\n');
  }

  async getArticles(tag, limit) {
    if (this.articles) {
      return this.articles;
    }

    const { data: { articles: { nodes } } } = await fetch(window.theme.routes.storefront_url, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.theme.settings.storefront_token,
      },
      body: JSON.stringify({
        query: `query getLatestTaggedArticles($query: String!, $limit: Int!) {
          articles(query: $query, first: $limit) {
            nodes {
              title
              authorV2 {
                name
              }
              image {
                altText
                width
                height
                ${this.imageSizes.map(({ name, width }) => (
                  name + ': url(transform: { maxWidth: ' + width + ' }) '
                ))}
                url
              }
              publishedAt
              onlineStoreUrl
            }
          }
        }`,
        variables: {
          query: `tag:'${tag}'`,
          limit,
        },
      })
    }).then(res => res.json());

    this.articles = nodes;
    return nodes;
  }
}

customElements.define('recent-articles', RecentArticles);
